import AddressSchema from '../Contacts/AddressSchema';

export default {
    title: "Edit Employee",
    type: "object",
    required: [
        "nameFirst",
        "nameLast",
        "usSocialSecurityNumber",
        "dateOfBirth",
        "gender",
        "relationshipStatus",
        "isUSCitizen",
        "phonePrimary",
        "emailPrimary",
        "addressMailing",
        "isDisabled",
        "isMedicareEligible",
        "isCurrentSmoker",
        "isPreviousSmoker",
        "hasOtherMedicalCoverage"
    ],
    properties: {
        namePrefix: {
            type: "string",
            title: "Name Prefix"
        },
        nameFirst: {
            type: "string",
            title: "First Name"
        },
        nameMiddle: {
            type: "string",
            title: "Middle Name"
        },
        nameLast: {
            type: "string",
            title: "Last Name"
        },
        nameNick: {
            type: "string",
            title: "Nickname"
        },
        nameSuffix: {
            type: "string",
            title: "Name Suffix"
        },
        prefersNickName: {
            type: "boolean",
            title: " Use Nickname?"
        },
        usSocialSecurityNumber: {
            type: "string",
            title: "U.S. Social Security Number"
        },
        dateOfBirth: {
            type: "string",
            title: "Date of Birth"
        },
        stateOfBirth: {
            type: "string",
            title: "State of Birth",
            enum: ['AL', 'AK', 'AS', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FM', 'FL', 'GA', 'GU', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MH', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'MP', 'OH', 'OK', 'OR', 'PW', 'PA', 'PR', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VI', 'VA', 'WA', 'WV', 'WI', 'WY'],
            enumNames: ['Alabama', 'Alaska', 'American Samoa', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 'District Of Columbia', 'Federated States Of Micronesia', 'Florida', 'Georgia', 'Guam', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Marshall Islands', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Northern Mariana Islands', 'Ohio', 'Oklahoma', 'Oregon', 'Palau', 'Pennsylvania', 'Puerto Rico', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virgin Islands', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming']
        },
        dateOfDeath: {
            type: "string",
            title: " "
        },
        gender: {
            type: "string",
            title: "Gender",
            enum: ['M', 'F'],
            enumNames: ['Male', 'Female']
        },
        relationshipStatus: {
            type: "string",
            title: "Relationship Status",
            enum: ['Divorced', 'Domestic Partnership', 'Legally Separated', 'Married', 'Single', 'Widowed']
        },
        isUSCitizen: {
            type: "boolean",
            title: "U.S. Citizen?"
        },
        racialHeritage: {
            type: "string",
            title: "Ethnicity",
            enum: ['American Indian or Alaska Native', 'Asian', 'Black or African American', 'Hispanic or Latino', 'Native Hawaiian or Other Pacific Islander', 'White', 'Two or More Races (Not Hispanic or Latino)', 'I do not wish to disclose']
        },
        preferredLanguage: {
            type: "string",
            title: "Preferred Language",
            enum: ['AR', 'ZH', 'EN', 'FR', 'DE', 'IT', 'JA', 'KO', 'RU', 'ES', 'ZZ'],
            enumNames: ['Arabic', 'Chinese', 'English', 'French', 'German', 'Italian', 'Japanese', 'Korean', 'Russian', 'Spanish', 'Other']
        },
        phonePrimary: {
            type: "string",
            title: "Phone (Primary)"
        },
        phoneAlternate: {
            type: "string",
            title: "Phone (Alternate)"
        },
        emailPrimary: {
            type: "string",
            title: "Email (Primary)"
        },
        emailAlternate: {
            type: "string",
            title: "Email (Alternate)"
        },
        addressMailing: {
            type: "object",
            title: "Address (Mailing)",
            properties: AddressSchema,
            required: ["street", "city", "state", "postalCode"]
        },
        addressPhysical: {
            type: "object",
            title: "Address (Physical)",
            properties: AddressSchema
        },
        isDisabled: {
            type: "boolean",
            title: "Disabled?"
        },
        isMedicareEligible: {
            type: "boolean",
            title: "Medicare Eligible?"
        },
        medicareNumber: {
            type: "string",
            title: "Medicare Number"
        },
        isCurrentSmoker: {
            type: "boolean",
            title: "Do you currently use Tobacco Products?"
        },
        isPreviousSmoker: {
            type: "boolean",
            title: "Have you used Tobacco Products in the past?"
        },
        previousSmokerQuitDate: {
            type: "string",
            title: "When did you stop using Tobacco Products?"
        },
        heightInInches: {
            type: "string",
            title: " "
        },
        weightInPounds: {
            type: "string",
            title: " "
        },
        hasOtherMedicalCoverage: {
            type: "boolean",
            title: "Do you have other medical coverage (not provided by your employer)?"
        },
        otherCoverageCarrierName: {
            type: "string",
            title: "Other Coverage Carrier Name"
        },
        otherCoverageMemberIdNumber: {
            type: "string",
            title: "Other Coverage Member ID Number"
        },
        otherCoveragePolicyType: {
            type: "string",
            title: "Other Coverage Policy Type",
            enum: ['Preferred Provider Organization (PPO)', 'Health Maintenance Organization (HMO)', 'Exclusive Provider Organization (EPO)', 'Point-of-Service (POS) plan', 'High-Deductible Health Plan (HDHP)']
        },
        otherCoveragePolicyNumber: {
            type: "string",
            title: "Other Coverage Policy Number"
        },
        otherCoverageEffectiveDate: {
            type: "string",
            title: "Other Coverage Effective Date"
        }
    }
} as const;